module.exports = __webpack_public_path__ + "img/bamboo-builders.6afb18a0.png";